import { Injectable } from '@angular/core';

import { EventDetailsColumnType, EventModel } from '@frontend/sports/betting-offer/feature/model';
import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { isNil } from 'lodash-es';

import { FeatureTab, LiveAlertMessage } from './showcase.model';
import { TrackShowcase } from './showcase.tracking.model';

@Injectable()
export class ShowcaseTrackingService {
    private actionEventByMediaTabs = {
        [EventDetailsColumnType.Stats]: 'stats tab',
        [EventDetailsColumnType.Animation]: 'animation tab',
        [EventDetailsColumnType.Video]: 'video tab',
    };

    private actionEventByHeaderNavTabs: Record<FeatureTab, string> = {
        [FeatureTab.Statistics]: 'stats tab',
        [FeatureTab.Simulation]: 'animation tab',
        [FeatureTab.Video]: 'video tab',
        [FeatureTab.Scoreboard]: '',
    };

    constructor(private trackingService: TrackingService) {}
    trackTabsInteractionForMedia(eventActiveId: EventDetailsColumnType, event: EventModel): void {
        this.trackTabsInteraction(event, this.actionEventByMediaTabs[eventActiveId]);
    }

    trackTabsInteractionForHeader(eventActiveId: FeatureTab, event: EventModel): void {
        this.trackTabsInteraction(event, this.actionEventByHeaderNavTabs[eventActiveId]);
    }

    trackEventPageClick(event: EventModel, index: number): void {
        const trackingData = this.getTrackData({
            labelEvent: 'Module Interactions',
            actionEvent: 'click',
            positionEvent: event.name,
            locationEvent: NOT_APPLICABLE,
            eventDetails: 'showcase event',
            sportId: event.sport.id,
            eventId: event.id,
            position: index,
        });

        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    trackHeaderExpandOrCollapseClick(event: EventModel, collapse: boolean): void {
        const trackingData = this.getTrackData({
            labelEvent: 'Module Interactions',
            actionEvent: 'click',
            positionEvent: event.name,
            locationEvent: NOT_APPLICABLE,
            eventDetails: collapse ? 'collapse' : 'expand',
            sportId: event.sport.id,
            eventId: event.id,
        });
        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    trackEventSwitcherEventClick(event: EventModel, index: number): void {
        const trackingData = this.getTrackData({
            labelEvent: 'Event Switcher',
            actionEvent: 'click',
            positionEvent: event.name,
            locationEvent: NOT_APPLICABLE,
            eventDetails: 'Event Switcher',
            sportId: event.sport.id,
            eventId: event.id,
            position: index,
        });
        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    trackGameAlertsEventRedirecting(alertMessage: LiveAlertMessage): void {
        const trackingData = this.getTrackData({
            labelEvent: 'Game Alerts',
            actionEvent: 'click',
            positionEvent: alertMessage.event,
            locationEvent: NOT_APPLICABLE,
            eventDetails: 'Game Alerts',
            sportId: alertMessage.sportId,
            eventId: alertMessage.eventId,
        });
        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    trackExpandGameAlerts(expanded: boolean): void {
        const trackingData = this.getTrackData({
            labelEvent: 'Game Alerts',
            actionEvent: 'click',
            positionEvent: NOT_APPLICABLE,
            locationEvent: NOT_APPLICABLE,
            eventDetails: expanded ? 'expand' : 'collapse',
        });

        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    private getTrackData(data: {
        labelEvent: string;
        actionEvent: string;
        positionEvent: string;
        locationEvent: string;
        eventDetails: string;
        sportId?: number;
        eventId?: string;
        position?: number;
    }): Partial<TrackShowcase> {
        const trackingData: Partial<TrackShowcase> = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'Showcase Module',
            [trackingConstants.COMPONENT_LABEL_EVENT]: data.labelEvent,
            [trackingConstants.COMPONENT_ACTION_EVENT]: data.actionEvent,
            [trackingConstants.COMPONENT_POSITION_EVENT]: data.positionEvent,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: data.locationEvent,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: data.eventDetails,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        };

        if (!isNil(data.sportId)) {
            trackingData[trackingConstants.SPORT_ID] = data.sportId.toString();
        }

        if (!isNil(data.eventId)) {
            trackingData[trackingConstants.SPORT_EVENT_ID] = data.eventId;
        }

        if (!isNil(data.position)) {
            //@ts-ignore allow dynamic accessor property
            trackingData[trackingConstants.COMPONENT_CONTENT_POSITION] = data.position.toString();
        }

        return trackingData;
    }

    private trackTabsInteraction(event: EventModel, tabTracking: string): void {
        const trackingData = this.getTrackData({
            labelEvent: 'Module Interactions',
            actionEvent: 'click',
            positionEvent: event.name,
            locationEvent: NOT_APPLICABLE,
            eventDetails: tabTracking,
            sportId: event.sport.id,
            eventId: event.id,
        });

        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }
}
